//Imports
//const winston = require('../config/winston');
//Apis
var admin1s = require('../api/location/admin1s.js');
var admin2s = require('../api/location/admin2s.js');
var admin3s = require('../api/location/admin3s.js');
var admin3Gvhs = require('../api/location/admin3Gvhs.js');
var admin3GvhVillages = require('../api/location/admin3GvhVillages.js');
//Controllers

/**
 * admin_1Controller.js
 *
 * @description :: Server-side logic for managing admin_1s.
 */
export default {

  /**
   * admin_1Controller.list()
   */
  admin1Boundaries: function () {

    
    //Copy Admin1s 
    return admin1s.list().then( response => {
      return response.data
      
    });
  },

  admin2Boundaries: function () {
    //Copy Admin2s 
    return admin2s.list().then(response => {
      //winston.info(`Admin2s records found = ${response.data.length}`);

      //winston.info(response);
      return response.data
    });
  },

  admin3Boundaries: function () {
    //Copy Admin3s 
    return admin3s.list().then(response => {
      //winston.info(`Admin3s records found = ${response.data.length}`);

      //winston.info(response);
      return response.data
    });
  },

  admin3gvhsBoundaries: function () {
    //Copy Admin3 Gvhs 
    return admin3Gvhs.list().then(response => {
      //winston.info(`Admin3 Gvhs records found = ${response.data.length}`);

      //winston.info(response);
      return response.data
    });
  },
  admin3gvhvillagesBoundaries: function () {
    //Copy Admin3 Gvhs 
    return admin3GvhVillages.list().then(response => {
      //winston.info(`Admin3 Gvh Villages records found = ${response.data.length}`);

      //winston.info(response);
      return response.data
    });

  },
};
